<template>
<section>
  <v-container fill-height grid-list-xs>
    <v-layout  row wrap justify-center align-center class="my-5">

      <v-flex class="animated fadeInUp text-xs-center">
        <h1 class="mb-2 font-weight-bold" :class="{'display-2': $vuetify.breakpoint.smAndDown, 'display-3': $vuetify.breakpoint.mdAndUp}">Thanks for signing up!</h1>
        <div class="subheading mb-3 text-xs-center">Check your email for a message from the She Team!</div>
        <v-btn href="#" @click.prevent="backHome" color="primary">Go Back</v-btn>
      </v-flex>

    </v-layout>
  </v-container>
</section>
</template>

<script>

export default {
  methods: {
    backHome() {
      this.$router.push({ name: 'home' })
    }
  },
  created() {
    this.$confetti.start({
      shape: 'heart',
      colors: ['#6D8BF0', '#6075BD', '#92a5e4']
    })
    setTimeout(() => this.$confetti.stop(), 3000)
  }
} 
</script>

<style>

</style>